<div class="auth-wrapper">
  <div class="auth-content subscribe">
    <div class="card">
      <div class="row no-gutters">
        <div class="col-md-4 col-lg-6 d-none d-md-flex d-lg-flex theme-bg align-items-center justify-content-center">
          <img src="assets/images/user/lock.png" alt="lock images" class="img-fluid" />
        </div>
        <div class="col-md-8 col-lg-6">
          <div class="card-body text-center">
            <div class="row justify-content-center">
              <div class="col-sm-10">
                <form [formGroup]="formGroup">
                  <h3 class="mb-4 mt-5">Cambiar clave</h3>
                  <div class="input-group mb-3 mt-2">
                    <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="currentPassword"
                      placeholder="Ingrese clave actual" formControlName="currentPassword" [ngClass]="{'is-invalid': isInvalidCurrentPassword || (currentPasswordField.hasError('required') || currentPasswordField.hasError('customBlankSpacesValidator')) && (currentPasswordField.dirty || currentPasswordField.touched)
                          }" (input)="onCurrentPasswordInput()" />
                    <span class="input-group-text" (click)="togglePasswordVisibility()">
                      <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                    </span>
                  </div>
                  <div class="input-group mb-3">
                    <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="newPassword"
                      placeholder="Ingrese la nueva clave" formControlName="newPassword" [ngClass]="{
                            'is-invalid': isInvalidNewPassword || (newPasswordField.hasError('required')) && (newPasswordField.dirty || newPasswordField.touched)
                          }" (input)="onNewPasswordInput()" />
                    <span class="input-group-text" (click)="togglePasswordVisibility()">
                      <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                    </span>
                  </div>
                  <div class="input-group mb-5">
                    <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="confirmNewPassword"
                      placeholder="Confirme la nueva clave" formControlName="confirmNewPassword" [ngClass]="{
                              'is-invalid': isInvalidConfirmNewPassword || (confirmNewPasswordField.hasError('required')) && (confirmNewPasswordField.dirty || confirmNewPasswordField.touched)
                            }" (input)="onConfirmNewPasswordInput()" />
                    <span class="input-group-text" (click)="togglePasswordVisibility()">
                      <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                    </span>
                  </div>
                  <button class="btn btn-primary mb-4" [disabled]="disableButton"
                    (click)="clickChangePassword()">Cambiar clave</button>
                  <br />
                  <label id="label-error-mensaje" class=""
                    style="background-color: white; text-align: left; color: rgb(121, 116, 116);">
                    {{errorMessage}}
                  </label>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>